import './RecommendationsSliderItem.sass';

import { Button } from '$uikit';
import React, { useCallback, useEffect } from 'react';
import { useProfileInfo, useTranslator, useUserInfo } from '$hooks';
import { Online, UnitName } from '$shared/components';
import { profileActions } from '$store/profile';
import { useDispatch } from 'react-redux';
import { CHAT, PROFILE } from '$shared/constants/pages';
import router from '$navigation/router';
import { formatBigNumber } from '$utils';
import { RecommendationsSliderItemProps } from '$core/Feed/RecommendationsSliderItem/RecommendationsSliderItem.interface';
import { cancelPreloadMedia, preloadMedia } from '../../../services/mediaLoader';

export const RecommendationsSliderItem = (props: RecommendationsSliderItemProps) => {
  const { userId, showUnfollow = false, onFollowed = undefined } = props;

  const user = useUserInfo(userId);
  const { isFollowFromMe } = useProfileInfo(userId);
  const t = useTranslator();
  const dispatch = useDispatch();

  useEffect(() => {
    if (user) {
      preloadMedia(user.photo, 'photo');
      return () => cancelPreloadMedia(user.photo);
    }
  }, [user]);

  const handleFollow = useCallback(() => {
    dispatch(profileActions.follow({ id: userId }));
    onFollowed && onFollowed();
  }, [dispatch, userId, onFollowed]);

  const handleUnfollow = useCallback(() => {
    dispatch(profileActions.unfollow(userId));
  }, [dispatch, userId]);

  const handleChat = useCallback(() => {
    router.navigate(CHAT, { peerId: userId });
  }, [dispatch, userId]);

  const navigateToProfile = () => router.navigate(PROFILE, { id: userId });

  return (
    <div className="RecommendationsItem">
      <div
        className="RecommendationsItem__photo"
        style={{ backgroundImage: `url(${user.photo}), url(${user.thumbnail})` }}
        onClick={navigateToProfile}
      />
      <div className="RecommendationsItem__profileInfo">
        <div className="RecommendationsItem__profileInfo__userInfo">
          <div
            className="RecommendationsItem__profileInfo__item _name"
            onClick={navigateToProfile}
          >
            <UnitName unit={user} />
          </div>
          <Online userId={userId} />
        </div>
        <div className="RecommendationsItem__profileInfo__item _followers">
          {`${formatBigNumber(user.followers)} ${t('followers_count_pref', {
            count: user.followers,
          })}`}
        </div>
      </div>
      {isFollowFromMe ? (
        showUnfollow ? (
          <Button size="small" mode="quinary" onClick={handleUnfollow}>
            {t('followed_button')}
          </Button>
        ) : (
          <Button size="small" mode="light" onClick={handleChat}>
            {t('write_message_button')}
          </Button>
        )
      ) : (
        <Button size="small" onClick={handleFollow}>
          {t('follow_button')}
        </Button>
      )}
    </div>
  );
};
